import { render, staticRenderFns } from "./exSynthesScoringIndex.vue?vue&type=template&id=4e52ebe8&scoped=true"
import script from "./exSynthesScoringIndex.vue?vue&type=script&lang=js"
export * from "./exSynthesScoringIndex.vue?vue&type=script&lang=js"
import style0 from "./exSynthesScoringIndex.vue?vue&type=style&index=0&id=4e52ebe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e52ebe8",
  null
  
)

export default component.exports